import React, { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import truck from "../../assets/images/svg/truck.svg";
import pinIcon from "../../assets/images/svg/pinIcon.svg";

const PodMap = ({ position, address, type }) => {
  const mapRef = useRef(null);
  const truckMarkerRef = useRef(null);
  const startMarkerRef = useRef(null);
  const endMarkerRef = useRef(null);
  const polylineRef = useRef(null);

  const iconUrl =
    type === "Pickup"
      ? "https://maps.google.com/mapfiles/ms/icons/red-dot.png"
      : "https://maps.google.com/mapfiles/ms/icons/blue-dot.png";

  // Dummy positions
  const initialPositions = [
    [51.505, -0.09],
    [51.506, -0.091],
    [51.507, -0.092],
    [51.508, -0.091],
    [51.509, -0.092],
    [51.51, -0.091],
    [51.511, -0.092],
  ];

  useEffect(() => {
    // Initialize the map
    mapRef.current = L.map("podmap", {
      center: position,
      zoom: 13,
    });

    // Add a tile layer to the map
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
      mapRef.current
    );

    // // Initialize the truck marker
    // truckMarkerRef.current = L.marker(position, {
    //   icon: L.icon({
    //     iconUrl: truck,
    //     iconSize: [25, 25],
    //   }),
    // }).addTo(mapRef.current);

    // Initialize the start marker (Dark Red Google Maps Icon)
    startMarkerRef.current = L.marker(position, {
      icon: L.icon({
        iconUrl,
        iconSize: [25, 25],
      }),
    })
      .addTo(mapRef.current)
      .bindPopup(address);

    startMarkerRef.current.openPopup();

    // // Initialize the end marker (Blue Icon)
    // endMarkerRef.current = L.marker(position, {
    //   icon: L.icon({
    //     iconUrl: "https://maps.google.com/mapfiles/ms/icons/blue-dot.png",
    //     iconSize: [25, 25],
    //   }),
    // }).addTo(mapRef.current);

    // // Initialize the polyline
    // polylineRef.current = L.polyline(initialPositions, {
    //   color: "purple",
    // }).addTo(mapRef.current);

    return () => {
      // Clean up the map instance on component unmount
      mapRef.current.remove();
    };
  }, []);

  return <div id="podmap" style={{ height: "166px", width: "100%" }}></div>;
};

export default PodMap;
